<div *ngIf="image" class="image">
	<img [src]="image" alt="" />
</div>
<div *ngIf="title" class="title" [innerHtml]="title"></div>
<div *ngIf="subtitle" class="subtitle" [innerHtml]="subtitle"></div>
